export const BUTTON_IDENTIFIER = 'btn';
export const INPUT_IDENTIFIER = 'inpt';
export const DROPDOWN_IDENTIFIER = 'dropdown';
export const OPTION_IDENTIFIER = 'option';

// Events
export const VIEW_EVENT = "View_Event";
export const CLICK_EVENT = "Click_Event";

// Locations
export const RESULTS_MODAL = "SignupSearchResultsModal";

// Home Page
export const PAGE_ORGANIZATION_HOME = 'View Signup Organization Home Page';
export const CLICK_START_BUTTON = `Click Signup page <Start>_${BUTTON_IDENTIFIER}`;
export const DONOR_SIGNUP_BUTTON_CLICKED = `Click Donors Signup Page <Donate>_${BUTTON_IDENTIFIER}`;

// Welcome Page
export const PAGE_WELCOME = 'View Signup Welcome Page';
export const START_BUTTON_CLICK = `Click Signup Welcome Page <Start>_${BUTTON_IDENTIFIER}`;

// Step 1 - Organization Name
export const ORG_NAME_PAGE = 'Signup Organization Name Page';
export const VIEW_ORG_NAME_PAGE = `View ${ORG_NAME_PAGE}`;
export const CLICK_ORG_NAME_NAME_INPUT = `Click ${ORG_NAME_PAGE} <Name>_${INPUT_IDENTIFIER}`;
export const CLICK_ORG_NAME_CITY_INPUT = `Click ${ORG_NAME_PAGE} <City>_${INPUT_IDENTIFIER}`;
export const CLICK_ORG_NAME_SEARCH_BTN = `Click ${ORG_NAME_PAGE} <Search>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_NAME_COUNTRY_DROPDOWN = `Click Signup Organization Name <Country>_${DROPDOWN_IDENTIFIER}`;
export const CLICK_ORG_NAME_COUNTRY_OPTION = `Click Signup Organization Name <Country>_${OPTION_IDENTIFIER}`;
export const CLICK_ORG_NAME_ZIP_INPUT = `Click Signup Organization Name <ZipCode>_${INPUT_IDENTIFIER}`;

// Organization Search
export const ORG_SEARCH_PAGE = 'Signup Organization Search Page';
export const VIEW_ORG_SEARCH_PAGE = `View ${ORG_SEARCH_PAGE}`;
export const CLICK_ORG_SEARCH_NAME_INPUT = `Click ${ORG_SEARCH_PAGE} <Name>_${INPUT_IDENTIFIER}`;
export const CLICK_ORG_SEARCH_CITY_INPUT = `Click ${ORG_SEARCH_PAGE} <City>_${INPUT_IDENTIFIER}`;
export const CLICK_ORG_SEARCH_SEARCH_BTN = `Click ${ORG_SEARCH_PAGE} <Search>_${BUTTON_IDENTIFIER}`;
export const VIEW_ORG_SEARCH_MODAL = `View Signup Organization Search Results Modal`;
export const CLICK_ORG_SELECT = `Click Signup Organization Search Results Modal <Select>_${BUTTON_IDENTIFIER}`;
export const CLICK_MANUAL_ENTRY = `Click Signup Organization Search Results Modal  <EnterDetails>_${BUTTON_IDENTIFIER}`;

// Confirm organization selection
export const VIEW_ORG_CONFIRMATION_MODAL =
    'View Signup Organization Confirmation Modal';
export const CLICK_AUTHORITY_CHECKBOX = `Click Signup Org Confirmation <Checkbox>_${INPUT_IDENTIFIER}`;
export const CLICK_ORGANIZATION_CONFIRM_BUTTON = `Click Signup Org Confirmation <Confirm>_${BUTTON_IDENTIFIER};`;
export const CLICK_ORGANIZATION_INVITE = `Click Signup Org Confirmation <Invite>_link`;
export const CLICK_GIVE_HERE = `Click Signup Org Confirmation <GiveHere>${BUTTON_IDENTIFIER}`;

export const ORGANIZATION_SEARCH_FILTERS_APPLIED =
    'Organization Search Filters Applied';
export const CLICK_ORG_SEARCH_CANT_FIND_BTN = `Click ${ORG_SEARCH_PAGE} <Can Not Find>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_SEARCH_MANUAL_SIGN_UP_BTN = `Click ${ORG_SEARCH_PAGE} <Sign Up>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_SEARCH_ADD_NEW_BUTTON = `Click ${ORG_SEARCH_PAGE} <Add New>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_SEARCH_SIGN_IN_BTN = `Click ${ORG_SEARCH_PAGE} <Sign In>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_SEARCH_CLAIM_BTN = `Click ${ORG_SEARCH_PAGE} <Claim>_${BUTTON_IDENTIFIER}`;
export const UNREGISTERED_ORGANIZATION_SELECTED =
    'Signup Unregistered Organization Selected';

// Organization Add - Manual Entry
export const ORG_MANUAL_ENTRY_PAGE = 'Signup Organization Manual Entry Page';
export const VIEW_ORG_MANUAL_ENTRY_PAGE = `View ${ORG_MANUAL_ENTRY_PAGE}`;
export const CLICK_ORG_MANUAL_ENTRY_PAGE_OK_BTN = `Click ${ORG_MANUAL_ENTRY_PAGE} <Ok>_${BUTTON_IDENTIFIER}`;

export const CLICK_ADDRESS_INPUT = `Click Signup Manual Form <Address>_${INPUT_IDENTIFIER}`;
export const CLICK_MANUAL_ENTRY_CITY_INPUT = `Click Signup Manual Form <City>_${INPUT_IDENTIFIER}`;
export const CLICK_MANUAL_ENTRY_ZIP_INPUT = `Click Signup Manual Form <ZipCode>_${INPUT_IDENTIFIER}`;
export const CLICK_MANUAL_ENTRY_PHONE_INPUT = `Click Signup Manual Form <Phone>_${INPUT_IDENTIFIER}`;
export const CLICK_MANUAL_ENTRY_NEXT_BTN = `Click Signup Manual Form <Next>_${BUTTON_IDENTIFIER}`;

// Already Registered
export const VIEW_ORG_ALREADY_REGISTERED_PAGE = `View Signup Organization Already Registered Page`;
export const CLICK_ALREADY_REGISTERED_SIGN_IN = `Click Signup Already Registered <SignIn>_${BUTTON_IDENTIFIER}`;
export const CLICK_ALREADY_REGISTERED_GIVE_HERE = `Click Signup Already Registered <GiveHere>_${BUTTON_IDENTIFIER}`;

// Invite Donee
export const PAGE_INVITE_DONEE = 'View Signup Invite Donee Page';
export const INVITE_DONEE_EMAIL_REQUESTED = `Click Signup Page <Invite Donee Email Requested>_${BUTTON_IDENTIFIER}`;
export const INVITE_DONEE_EMAIL_SENT_SUCCESSFULLY =
    'View Signup Invite Donee Email Sent Successfully Page';

// Step 2 - Donee/Organization Type
export const ORG_TYPE_PAGE = 'Signup Organization Type Page';
export const VIEW_ORG_TYPE_PAGE = `View ${ORG_TYPE_PAGE}`;
export const CLICK_ORG_TYPE_PAGE_OK_BTN = `Click ${ORG_TYPE_PAGE} <Ok>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_TYPE_PAGE_CHURCH_BTN = `Click ${ORG_TYPE_PAGE} <Church>_${BUTTON_IDENTIFIER}`;
export const CLICK_ORG_TYPE_PAGE_NON_PROFIT_BTN = `Click ${ORG_TYPE_PAGE} <Non Profit>_${BUTTON_IDENTIFIER}`;

// Step 3 - User Name
export const USER_NAME_PAGE = 'View Signup User Name Page';
export const VIEW_USER_NAME_PAGE = `View ${USER_NAME_PAGE}`;
export const CLICK_USER_NAME_PAGE_OK_BTN = `Click ${USER_NAME_PAGE} <Ok>_${BUTTON_IDENTIFIER}`;

// Step 4 - User Title
export const USER_TITLE_PAGE = 'Signup User Title Page';
export const VIEW_USER_TITLE_PAGE = `View ${USER_TITLE_PAGE}`;
export const CLICK_USER_TITLE_PAGE_OK_BTN = `Click ${USER_TITLE_PAGE} <Ok>_${BUTTON_IDENTIFIER}`;

// Step 5 - User Email
export const USER_EMAIL_PAGE = 'Signup User Email Page';
export const VIEW_USER_EMAIL_PAGE = `View ${USER_EMAIL_PAGE}`;
export const CLICK_USER_EMAIL_PAGE_OK_BTN = `Click ${USER_EMAIL_PAGE} <Ok>_${BUTTON_IDENTIFIER}`;

// Step 6 - User Phone
export const USER_PHONE_PAGE = 'Signup User Phone Page';
export const VIEW_USER_PHONE_PAGE = `View ${USER_PHONE_PAGE}`;
export const CLICK_USER_PHONE_PAGE_OK_BTN = `Click ${USER_PHONE_PAGE} <Ok>_${BUTTON_IDENTIFIER}`;

// Step 7 - EIN Number
export const PAGE_EIN = 'Signup Page EIN';

// Final Step
export const FINAL_PAGE = 'Signup Final Step Page';
export const VIEW_FINAL_PAGE = `View ${FINAL_PAGE}`;
export const CLICK_FINAL_PAGE_CONTINUE_BTN = `Click ${FINAL_PAGE} <Continue>_${BUTTON_IDENTIFIER}`;

// Password Step
export const USER_PASSWORD_PAGE = 'Signup User Password Page';
export const VIEW_USER_PASSWORD_PAGE = `View ${USER_PASSWORD_PAGE}`;
export const CLICK_USER_PASSWORD_PAGE_SUBMIT_BTN = `Click ${FINAL_PAGE} <Submit>_${BUTTON_IDENTIFIER}`;

export const SIGNUP_SUCCESSFUL = 'View Signup Successful Page';

// Signup Submitted (Congrats Page)
export const CONGRATS_PAGE = 'Signup Congratulations Page';
export const VIEW_CONGRATS_PAGE = `View ${CONGRATS_PAGE}`;
export const CLICK_CONGRATS_PAGE_SIGN_IN_BTN = `Click ${CONGRATS_PAGE} <Sign In>_${BUTTON_IDENTIFIER}`;
export const CLICK_CONGRATS_PAGE_RESEND_BTN = `Click ${CONGRATS_PAGE} <Resend>_${BUTTON_IDENTIFIER}`;
export const CLICK_CONGRATS_PAGE_SUPPORT_BTN = `Click ${CONGRATS_PAGE} <ContactSupport>_${BUTTON_IDENTIFIER}`;

// Misc.
export const CLICK_BACK = `Click Signup Page <Back>_${BUTTON_IDENTIFIER}`;
export const CLICK_CLOSE = `Click Signup Page <Close>_${BUTTON_IDENTIFIER}`;
export const CLICK_SKIP = `Signup Click <Skip>_${BUTTON_IDENTIFIER}`;
export const HELP_BUTTON_CLICKED = `Click Signup Page <Help>_${BUTTON_IDENTIFIER}`;
